<template>
  <div class="p-4 shadow flex flex-col justify-start gap-4 w-80">
    <SelectInput
      v-model="serviceCategoryId"
      data-cy="drawer-service-category-select"
      label="Service Category"
      :options="serviceCategoryOptions"
      :body-render="false"
      :validation="firstErrorMessage(v$.serviceCategoryId) ? 'error' : ''"
      :helper-text="firstErrorMessage(v$.serviceCategoryId)"
      :filter="true"
      filter-placeholder="Search categories..."
    />
    <Button
      label="Save"
      class="w-full"
      data-cy="drawer-service-category-save"
      @click="handleSave"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Button from "@/components/Seranova/Buttons/Button.vue";
import SelectInput from "@/components/Seranova/SelectInput/SelectInput.vue";
import {
  AppointmentServiceCategory,
  AppointmentV2
} from "@/typings/appointment";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

const emit = defineEmits(["saved"]);
const store = useStore();
const props = defineProps<{ appointment: AppointmentV2 }>();
const serviceCategoryId = ref(props.appointment?.service_category.id);
const v$ = useVuelidate(
  {
    serviceCategoryId: {
      required: helpers.withMessage("Service category required", required)
    }
  },
  { serviceCategoryId }
);
onMounted(() => {
  if (store.state.serviceCategories.length === 0) {
    store.dispatch("fetchServiceCategories");
  }
});
const serviceCategoryOptions = computed(() =>
  store.state.serviceCategories
    .filter((sc: AppointmentServiceCategory) => !sc.archived)
    .map((sc: { id: number; name: string }) => ({
      label: sc.name,
      value: sc.id
    }))
);

const handleSave = async () => {
  const valid = await v$.value.$validate();
  if (!valid) return;
  await store.dispatch("updateAppointmentServiceCategory", {
    appointmentId: props.appointment.id,
    serviceCategoryId: serviceCategoryId.value
  });
  window.notify.success("Appointment service category updated");
  emit("saved");
  tippy.hideAll();
};
</script>

<style lang="scss" scoped></style>
